// 场地服务
import Log from "../view/log";
import SiteReservationNav from "../view/SiteReservation/SiteReservationNav";
import SiteOverView from "../view/SiteReservation/SiteOverView/SiteOverView";
import SiteFacilitiesManage from "../view/SiteReservation/SiteFacilities/SiteFacilitiesManage";
import SiteFacilitiesAdd from "../view/SiteReservation/SiteFacilities/SiteFacilitiesAdd";
import SiteFacilitiesModify from "../view/SiteReservation/SiteFacilities/SiteFacilitiesModify";
import SiteManagement from "../view/SiteReservation/SiteManagement/SiteManagement";
import SiteAdd from "../view/SiteReservation/SiteManagement/SiteAdd";
import SiteCurrent from "../view/SiteReservation/SiteManagement/SiteCurrent";
import SiteModify from "../view/SiteReservation/SiteManagement/SiteModify";
import BespokeRecord from "../view/SiteReservation/BespokeRecord/BespokeRecord";
import SitePayRecord from "../view/SiteReservation/PaymentRecord/SitePayRecord";
import SiteBill from "../view/SiteReservation/SiteBill/SiteBill";
import SiteBillModify from "../view/SiteReservation/SiteBill/SiteBillModify";

export default [
  /* 场地服务 */
  {
    path: "/site_reservation/site_over_view",
    name: "site-over-view",
    components: {
      default: SiteReservationNav,
      a: SiteOverView
    }
  },
  {
    path: "/site_reservation/site_facilities_manage",
    name: "site-facilities-manage",
    components: {
      default: SiteReservationNav,
      a: SiteFacilitiesManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/site_reservation/site_facilities_add",
    name: "site-facilities-add",
    components: {
      default: SiteReservationNav,
      a: SiteFacilitiesAdd
    }
  },
  {
    path: "/site_reservation/site_facilities_modify/:id",
    name: "site-facilities-modify",
    components: {
      default: SiteReservationNav,
      a: SiteFacilitiesModify
    }
  },
  {
    path: "/site_reservation/site_management",
    name: "site-management",
    components: {
      default: SiteReservationNav,
      a: SiteManagement
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/site_reservation/site_add",
    name: "site-add",
    components: {
      default: SiteReservationNav,
      a: SiteAdd
    }
  },
  {
    path: "/site_reservation/site_current/:id",
    name: "site-current",
    components: {
      default: SiteReservationNav,
      a: SiteCurrent
    }
  },
  {
    path: "/site_reservation/site_modify/:id",
    name: "site-modify",
    components: {
      default: SiteReservationNav,
      a: SiteModify
    }
  },
  {
    path: "/site_reservation/bespoke_record",
    name: "bespoke-record",
    components: {
      default: SiteReservationNav,
      a: BespokeRecord
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/site_reservation/site_pay_record",
    name: "site-pay-record",
    components: {
      default: SiteReservationNav,
      a: SitePayRecord
    }
  },
  {
    path: "/site_reservation/site_bill",
    name: "site-bill",
    components: {
      default: SiteReservationNav,
      a: SiteBill
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/site_reservation/site_bill_modify/:id",
    name: "site-bill-modify",
    components: {
      default: SiteReservationNav,
      a: SiteBillModify
    }
  },
  /* 场地服务 */
  // 场地服务操作日志
  {
    path: "/site_reservation_log",
    name: "site-reservation-log",
    components: {
      default: SiteReservationNav,
      a: Log
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/SiteReservation.js